import Link from "next/link";
import base from "lib/base";
import styles from "./NewsGrid.module.css";

function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
}

function resolveCdnImage(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = String(path).replace(/^\/+/, "");
  const cdnRoot = String(base.cdnUrl || "").replace(/\/+$/, "");
  return `${cdnRoot}/450/${normalized}`;
}

function resolveCdnUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = String(path).replace(/^\/+/, "");
  const cdnRoot = String(base.cdnUrl || "").replace(/\/+$/, "");
  return `${cdnRoot}/${normalized}`;
}

function stripHtml(html) {
  if (!html) return "";
  return html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
}

function truncateWords(text, maxWords) {
  if (!text) return "";
  const words = text.split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(" ") + "...";
}

function getExcerpt(html, maxWords = 30) {
  const text = stripHtml(html);
  return truncateWords(text, maxWords);
}

export default function NewsGrid({ news = [] }) {
  if (news.length === 0) return null;

  return (
    <div className={styles.gridContainer}>
      {news.map((article) => (
        <Link
          key={article._id}
          href={`/news/${article.slug || article._id}`}
          className={styles.card}
        >
          <div className={styles.imageWrapper}>
            {article.pictures && article.pictures[0] ? (
              <img
                src={resolveCdnImage(article.pictures[0])}
                alt={article.name || "Article"}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                loading="lazy"
                decoding="async"
              />
            ) : (
              <div className={styles.placeholder} />
            )}
          </div>
          <div className={styles.content}>
            <h3 className={styles.title}>{article.name}</h3>
            {article.createdAt && (
              <p className={styles.publishDate}>
                {formatDate(article.createdAt)}
              </p>
            )}
            <p className={styles.excerpt}>
              {getExcerpt(
                article.details || article.intro || article.description,
                25,
              )}
            </p>
            {article.authors && (
              <div className={styles.authorInfo}>
                {article.authors.avatar && (
                  <img
                    src={resolveCdnUrl(article.authors.avatar)}
                    alt={article.authors.name || "Author"}
                    width={24}
                    height={24}
                    className={styles.authorAvatar}
                    loading="lazy"
                    decoding="async"
                  />
                )}
                <span className={styles.authorName}>
                  {article.authors.name}
                </span>
              </div>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}
